import { StackShim as Stack } from '@fluentui/react-migration-v8-v9';
import { DefaultPalette, FontSizes, NeutralColors } from '@fluentui/react';
import { Button } from '@fluentui/react-components';
import { ChevronRightRegular, ChevronDownRegular, TrophyRegular } from '@fluentui/react-icons';
import React, { CSSProperties } from 'react';
import { MessagingColors } from '../../../../app/common/styles/CommonStyleObjects';

interface IProcessTemplateMilestoneCardHeaderProps {
  onHeaderClick: (collapsed: boolean) => void;
  title: string;
  contentIsCollapsed: boolean;
  isGoalMilestone: boolean;
}
const ProcessTemplateMilestoneCardHeader = (
  props: IProcessTemplateMilestoneCardHeaderProps,
): JSX.Element => {
  const { onHeaderClick, title, contentIsCollapsed, isGoalMilestone } = props;
  const cardHeaderStackStyles = {
    padding: 20,
    backgroundColor: isGoalMilestone ? MessagingColors.warning : NeutralColors.white,
    borderBottom: `1px solid ${NeutralColors.gray20}`,
  } as CSSProperties;
  const cardHeaderFontStyles = {
    margin: '0',
    fontSize: FontSizes.size14,
    fontWeight: 600,
  };
  const buttonWrapperStyles = { display: 'flex', alignItems: 'center' };
  const buttonStyles = {
    marginRight: 10,
    color: DefaultPalette.blue,
    minHeight: '24px',
    minWidth: '24px',
  };

  return (
    <Stack
      horizontal
      verticalAlign="center"
      horizontalAlign="space-between"
      style={cardHeaderStackStyles}
      aria-expanded={!contentIsCollapsed}
    >
      <div style={buttonWrapperStyles}>
        <Button
          appearance="subtle"
          style={buttonStyles}
          icon={contentIsCollapsed ? <ChevronRightRegular /> : <ChevronDownRegular />}
          title={contentIsCollapsed ? `Expand ${title}` : `Collapse ${title}`}
          aria-label={contentIsCollapsed ? `Expand ${title}` : `Collapse ${title}`}
          aria-expanded={!contentIsCollapsed}
          onClick={(): void => {
            onHeaderClick(!contentIsCollapsed);
          }}
        />
        <h3 style={cardHeaderFontStyles}>
          {title}
          {isGoalMilestone && (
            <>
              <span> - Goal Milestone </span>
              <TrophyRegular />
            </>
          )}
        </h3>
      </div>
    </Stack>
  );
};
export default ProcessTemplateMilestoneCardHeader;
